export class NewsFeed{
  name:string;
  language:string;
  html_url:string;
  description:string;
  stars:any;
  forks:any;
  watchers:any;
}



/** WEBPACK FOOTER **
 ** ./src/app/home/NewsFeed.ts
 **/